module.exports = __webpack_public_path__ + "static/media/icon-badge.0c6dedf8.png";